import { Component, OnInit } from '@angular/core';
import {User} from "../../../models/user";
import {NotificationProvider} from "../../../models/notificationProvider";
import {LocalStorageService} from "../../../services/local-storage.service";
import {CommonService} from "../../../services/common.service";
import {Router} from "@angular/router";
import {ToastMessagesService} from "../../../services/toast-messages.service";
import {FileService} from "../../../services/file.service";

@Component({
  selector: 'app-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss']
})
export class UserSettingsComponent implements OnInit {
  pageTitle: string;
  imageSource: any;
  user: any;
  currentUser: User;
  notificationProviders: NotificationProvider[];
  isUserInfoLoading: boolean;
  isProvidersLoading: boolean;
  contactInfo: any;
  isInfoLoading: boolean;
  constructor( public commonService: CommonService,
               public router: Router, public toastMessagesService: ToastMessagesService) {
    this.pageTitle= 'Ρυθμίσεις χρήστη';
  }

  async ngOnInit() {
    await this.getParentInfo();
    await this.getNotificationProviders();
  }

  async getParentInfo() {
    try {
      const userInfoRequest = await this.commonService.getList(`people/parent`);
      this.currentUser = userInfoRequest.object[0] as User;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isUserInfoLoading = false;
    }
  }

  async getNotificationProviders() {
    try {
      const providersRequest = await this.commonService.getList(`common/notification_providers`);
      this.notificationProviders = providersRequest.object as NotificationProvider[];
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isProvidersLoading = false;
    }
  }

}
